"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _facades = require("../facades");
var _nachweisTypConstants = require("./nachweisTypConstants");
var getAusbildungStartDateForNachweis = function getAusbildungStartDateForNachweis(nachweis, userSettings) {
  if (!nachweis || !userSettings || !userSettings.ausbildungsStartByBeruf) {
    return undefined;
  }
  return userSettings.ausbildungsStartByBeruf[nachweis.ausbildungsberuf];
};
var hasValidPeriodInputs = function hasValidPeriodInputs(selectedPeriod, ausbildungStartDate) {
  return (0, _facades.isValid)(ausbildungStartDate) && !isNaN(selectedPeriod) && !!selectedPeriod;
};
var getWeekDateString = function getWeekDateString(selectedWeek, ausbildungStartDate) {
  if (!hasValidPeriodInputs(selectedWeek, ausbildungStartDate)) return '';
  var week = (0, _facades.addWeeks)((0, _facades.startOfWeek)(ausbildungStartDate, {
    weekStartsOn: 1
  }), selectedWeek - 1);
  var startDate = (0, _facades.format)((0, _facades.startOfWeek)(week, {
    weekStartsOn: 1
  }), 'dd.MM.yy');
  var endDate = (0, _facades.format)((0, _facades.endOfWeek)(week, {
    weekStartsOn: 1
  }), 'dd.MM.yy');
  return "".concat(startDate, " - ").concat(endDate);
};
var getMonthDateString = function getMonthDateString(selectedMonth, ausbildungStartDate) {
  if (!hasValidPeriodInputs(selectedMonth, ausbildungStartDate)) return '';
  var dateByWeekNumber = (0, _facades.addMonths)(ausbildungStartDate, selectedMonth - 1);
  var startDate = (0, _facades.format)((0, _facades.startOfMonth)(dateByWeekNumber), 'dd.MM.yy');
  var endDate = (0, _facades.format)((0, _facades.endOfMonth)(dateByWeekNumber), 'dd.MM.yy');
  return "".concat(startDate, " - ").concat(endDate);
};
var _default = exports["default"] = {
  getHighestNumber: function getHighestNumber(userAusbildungsNachweise) {
    try {
      if (!userAusbildungsNachweise || Object.keys(userAusbildungsNachweise).length === 0 || userAusbildungsNachweise.length === 0) {
        return 0;
      }
      if (userAusbildungsNachweise.sort) {
        var _numbers = userAusbildungsNachweise.map(function (i) {
          return parseInt(i.nummer, 10);
        });
        var _sorted = _numbers.sort(function (x, y) {
          return x - y;
        });
        return _sorted[_sorted.length - 1];
      }
      var numbers = Object.keys(userAusbildungsNachweise).map(function (key) {
        return parseInt(userAusbildungsNachweise[key].nummer, 10);
      });
      var sorted = numbers.sort(function (x, y) {
        return x - y;
      });
      return sorted[sorted.length - 1];
    } catch (e) {
      return 0;
    }
  },
  getLowestNumber: function getLowestNumber(userAusbildungsNachweise) {
    try {
      if (!userAusbildungsNachweise || Object.keys(userAusbildungsNachweise).length === 0 || userAusbildungsNachweise.length === 0) {
        return 0;
      }
      if (userAusbildungsNachweise.sort) {
        var _numbers2 = userAusbildungsNachweise.map(function (i) {
          return parseInt(i.nummer, 10);
        });
        var _sorted2 = _numbers2.sort(function (x, y) {
          return y - x;
        });
        return _sorted2[_sorted2.length - 1];
      }
      var numbers = Object.keys(userAusbildungsNachweise).map(function (key) {
        return parseInt(userAusbildungsNachweise[key].nummer, 10);
      });
      var sorted = numbers.sort(function (x, y) {
        return y - x;
      });
      return sorted[sorted.length - 1];
    } catch (e) {
      return 0;
    }
  },
  getWeekDateString: getWeekDateString,
  getMonthDateString: getMonthDateString,
  getDateRangeStringByNachweis: function getDateRangeStringByNachweis(nachweis, userSettings) {
    var startDate = getAusbildungStartDateForNachweis(nachweis, userSettings);
    if (!startDate || isNaN(nachweis.nummer) || !nachweis.nummer) return '';
    return (0, _nachweisTypConstants.isMonthlyType)(nachweis.typ) ? getMonthDateString(nachweis.nummer, new Date(startDate)) : getWeekDateString(nachweis.nummer, new Date(startDate));
  },
  nachweisNumberExists: function nachweisNumberExists(userAusbildungsNachweise, selectedWeek) {
    if (!userAusbildungsNachweise || userAusbildungsNachweise.length === 0) {
      return false;
    }
    if (userAusbildungsNachweise.find) {
      return userAusbildungsNachweise.find(function (i) {
        return i.nummer === selectedWeek;
      }) !== undefined;
    }
    return Object.keys(userAusbildungsNachweise).some(function (k) {
      return userAusbildungsNachweise[k].nummer === selectedWeek;
    });
  },
  getWeekNumberByDate: function getWeekNumberByDate(startDate, date) {
    var OFFSET = 1;
    return (0, _facades.differenceInWeeks)(date, (0, _facades.startOfWeek)(startDate, {
      weekStartsOn: 1
    })) + OFFSET;
  },
  getMonthNumberByDate: function getMonthNumberByDate(startDate, date) {
    var OFFSET = 1;
    return (0, _facades.differenceInMonths)(date, (0, _facades.startOfMonth)(startDate)) + OFFSET;
  }
};